require('./openYoungCardDocumentationState.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { PAGE_GENERIC, recordLink, recordPath } = require('utilities/tagging');
// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
// @ helpers
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class OpenYoungCardDocumentationState extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchDocumentationSuccess: false,
        };

        this.handleDisclaimerLinkUrl = this.handleDisclaimerLinkUrl.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { immOpenYoungDocumentation } = nextProps;
        let stateUpdates = null;

        if (prevState.fetchDocumentationSuccess !== immOpenYoungDocumentation.get('fetchDocumentationSuccess')) {
            const documentationRemainingDays = immOpenYoungDocumentation.getIn(['documentationState', 'remainingDays']);
            const documentationState = immOpenYoungDocumentation.getIn(['documentationState', 'state']);
            if (documentationState === '4') {
                recordLink('openyoung-reminder-documentacion-bloqueada', 'vista');
            } else if (['2', '3'].includes(documentationState)) {
                recordLink(`openyoung-reminder-documentacion-${documentationRemainingDays}`, 'vista');
            }
            stateUpdates = {
                fetchDocumentationSuccess: immOpenYoungDocumentation.get('fetchDocumentationSuccess')
            };
        }
        return stateUpdates;
    }

    componentDidMount() {
        const {
            getCardDocumentationState,
            immCard,
            immOpenYoungDocumentation,
        } = this.props;
        const tagging = immCard.get('tagging');

        recordPath('upload-documentation', PAGE_GENERIC, '', '', tagging);

        if (!immOpenYoungDocumentation.get('fetchDocumentationSuccess')) {
            getCardDocumentationState(immCard.get('cardId'));
        }
    }

    handleDisclaimerLinkUrl() {
        const { immOpenYoungDocumentation } = this.props;
        const documentationRemainingDays = immOpenYoungDocumentation.getIn(['documentationState', 'remainingDays']);
        const documentationState = immOpenYoungDocumentation.getIn(['documentationState', 'state']);
        
        if (documentationState === '4') {
            recordLink('openyoung-reminder-documentacion-bloqueada', 'ir a proceso');
        } else if (['2', '3'].includes(documentationState)) {
            recordLink(`openyoung-reminder-documentacion-${documentationRemainingDays}`, 'ir a proceso');
        }
    }
    
    componentWillUnmount(){
        const {getCardDocumentationReset} =this.props;
        getCardDocumentationReset()
    }

    render() {
        const {
            immCard,
            immOpenYoungDocumentation,
            immVariables,
        } = this.props;

        let body = null;

        if (immOpenYoungDocumentation.get('fetchDocumentationSuccess')) {
            const documentationState = immOpenYoungDocumentation.getIn(['documentationState', 'state']);

            if (documentationState !== '1') {
                const documentationRemainingDays = immOpenYoungDocumentation.getIn(['documentationState', 'remainingDays']);
                const disclaimerLinkUrl = `/myprofile/cards/${immCard.get('cardId')}/upload-documentation`;
                const disclaimerLink = (
                    <OKLink onClick={this.handleDisclaimerLinkUrl} to={disclaimerLinkUrl}>
                        <FormattedText value="openYoungDocumentationDisclaimer-openYoungDocumentationDisclaimer_linkText" />
                    </OKLink>
                );

                let bodyCC;
                let disclaimerType;
                let disclaimerTitle = formatText('openYoungDocumentationDisclaimer-openYoungDocumentationDisclaimer_pendingDocumentationTitle'); 
                let disclaimerText = (
                    <React.Fragment>
                        <FormattedText 
                            injectedStrings={[documentationRemainingDays]}
                            value="openYoungDocumentationDisclaimer-openYoungDocumentationDisclaimer_addDocumentationDisclaimer"
                        />
                        &nbsp;
                        {disclaimerLink}
                    </React.Fragment>
                );
    
                switch (documentationState) {
                    case '2':
                        disclaimerType = 'informative';
                        break;
                    case '3':
                        disclaimerType = 'important';
                        break;
                    case '4':
                        disclaimerType = 'warning';
                        disclaimerTitle = formatText('openYoungDocumentationDisclaimer-openYoungDocumentationDisclaimer_blockedCardTitle');
                        disclaimerText = (
                            <React.Fragment>
                                <FormattedText value="openYoungDocumentationDisclaimer-openYoungDocumentationDisclaimer_blockedCardDisclaimer1" />
                                &nbsp;
                                {disclaimerLink}
                                <FormattedText 
                                    injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                                    value="openYoungDocumentationDisclaimer-openYoungDocumentationDisclaimer_blockedCardDisclaimer2"
                                />
                            </React.Fragment>
                        );
                        break;
                }

                if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
                    bodyCC = (
                        <BlockInfo extraClass="card-documentation-state__block-info">
                            <FormattedText value="openYoungDocumentationDisclaimer-openYoungDocumentationDisclaimer_cantAddDocuments" />
                        </BlockInfo>
                    );
                }

                body = (
                    <div className="card-documentation-state">
                        <OKMessage 
                            title={disclaimerTitle}
                            type={disclaimerType}
                        >
                            {disclaimerText}
                        </OKMessage>
                        {bodyCC}
                    </div>
                );
            }
        }

        return body;
    }
}

OpenYoungCardDocumentationState.propTypes = {
    getCardDocumentationState: PropTypes.func.isRequired,
    immCard: PropTypes.object.isRequired,
    immOpenYoungDocumentation: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    getCardDocumentationReset:PropTypes.func.isRequired
};

module.exports = OpenYoungCardDocumentationState;
